export const SET_SPINNER_VISIBLE = 'SET_SPINNER_VISIBLE';
export const SET_SPINNER_HIDDEN = 'SET_SPINNER_HIDDEN';

export const SET_NOTIFY_TRUE = 'SET_NOTIFY_TRUE';
export const SET_NOTIFY_FALSE = 'SET_NOTIFY_FALSE';
